export enum MESSAGE_TYPE {
    SUCCESS = 'success-snackbar',
    WARNING = 'warning-snackbar',
    ERROR = 'error-snackbar',
    INFO = 'info-snackbar',
    DEFAULT = 'default-snackbar'
}
